import React from 'react';

import clsx from 'clsx';

export type TextareaProps = {
  name: string;
  hasError?: boolean;
  'data-testid': string;
} & React.ComponentPropsWithoutRef<'textarea'>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const { hasError, className, ...textareaProps } = props;

    return (
      <textarea
        ref={ref}
        className={clsx(
          'border rounded px-5 py-[11px] placeholder:text-sm',
          !hasError && 'border-grey-70',
          hasError && 'border-red-70',
          className
        )}
        {...textareaProps}
      />
    );
  }
);

Textarea.displayName = 'Textarea';
